import { Component, Input, SimpleChanges } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-check-fitment',
  templateUrl: './check-fitment.component.html',
  styleUrls: ['./check-fitment.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf]
})
export class CheckFitmentComponent {
  tableKeys: string[] = [];
  tableData: any[] = [];
  headerLabels: string[] = [];

  @Input() fitmentData: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fitmentData']?.currentValue) {
      this.prepareTable(this.fitmentData);
    }
  }

  prepareTable(res: any) {
    this.tableData = res?.[0]?.data?.fitment_data || [];
    if (this.tableData?.length > 0) {
      const allKeys = Object.keys(this.tableData[0]);
      this.tableKeys = allKeys.filter(key =>
        this.tableData.some(row =>
          row[key] !== null &&
          row[key] !== undefined &&
          row[key] !== ''
        )
      );
      this.headerLabels = this.tableKeys.map(key =>
        key
          .replace(/_/g, ' ')
          .replace(/\b\w/g, char => char.toUpperCase())
      );
    }
  }
}